import ListHeader from "@/common/components/ListHeader";
import { UserCog } from "lucide-react";
import Tabs from "@/common/components/Tabs";
import { defaultTabs } from "../../constants/tmaisUsersTabs.constant";

const TmaisUsers = () => {
  return (
    <div className="flex flex-col">
      <ListHeader
        Icon={<UserCog className="w-10 h-10" strokeWidth={1} />}
        title="Clientes T+"
      />
      <Tabs
        tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none mt-4"
        tabsTriggerClassName="flex-1 h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
        tabsContentClassName="mt-6"
        tabsList={defaultTabs()}
      />
    </div>
  );
};

export default TmaisUsers;
